<template>
  <!-- 账号管理设置页面 -->
  <!-- 设置页面的内容区域 -->
  <!-- // 代号 20241212-1  整页-->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->
      <config-hang @click.native="threadNetworkNewStart()">
        <span slot="config_hang_ele2">创建新的网络</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>
      <config-hang @click.native="networkManage()">
        <span slot="config_hang_ele2">当前网络管理</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>

      <config-hang @click.native="deviceNetIn()">
        <span slot="config_hang_ele2">协助设备入网</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>


      <config-hang v-if="oneHostData.gatewayType == 6" @click.native="deviceSet('setGateway')">
        <span slot="config_hang_ele2">设置主机地址</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>

      <config-hang @click.native="changeHostInfo()">
        <span slot="config_hang_ele2">主机信息管理</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>



    </div>
  </div>
</template>

<script>
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";
export default {
  data() {
    return {
      oneHostDeviceListData: {
        ////服务器请求到的主机下面的设备列表
        offLineList: [],
        onLineList: [],
        threadNewProductList: []
      },
      oneHostData: {
        ////一个主机的信息
      },
      query: {}
    };
  },
  components: {
    configHang,
    configTitleHang
  },
  methods: {
    deviceNetIn() {
      console.log("设备入网");
      this.$router.push({
        path: "threadDeviceNetIn",
        query: null
      });
    },
    deviceSet(type) {
      if (type == "setGateway") {
        //获取当前用户可用推荐的网关地址(thread 网关)
        this.$request({
          method: "post",
          url: "/gateway/getUsableBorderAddress",
          data: {
            token: this.$store.state.token,
            gatewayId: this.oneHostData.gatewayId, //  value.gatewayId
          }
        })
          .then(res => {
            if (res.data.code != 0) {
              this.$showTipsToast(3, res.data.message);
              ////说明信息填写错误,控制失败了，
              return;
            } else {
              ////、控制成功了
              let data = res.data.data; ////拿到服务器返回的数据结果
              console.log("拿到可用的网关地址:", data.borderAddress);
              this.query.address = data.borderAddress;
              this.$router.push({
                path: "threadAddNewDevice",
                query: this.query
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    networkManage() {
      //获取当前网关的 thread 网络信息
      this.$request({
        method: "post",
        url: "/gateway/getThreadNetworkInfo",
        data: {
          token: this.$store.state.token,
          gatewayId: this.oneHostData.gatewayId, //  value.gatewayId
          kind: 1 //1 获取当前活跃的网络信息 2 获取随机新的网络信息
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            let data = res.data.data; ////拿到服务器返回的数据结果
            console.log("获取到网络信息:", data);
            this.$router.push({
              path: "threadNetworkManage",
              query: data
            });
          }
        })
        .catch(error => {
          console.log(error);
        });

    },
    threadNetworkNewStart() {
      //获取当前网关的 thread 网络信息
      this.$request({
        method: "post",
        url: "/gateway/getThreadNetworkInfo",
        data: {
          token: this.$store.state.token,
          gatewayId: this.oneHostData.gatewayId, //  value.gatewayId
          kind: 2 //1 获取当前活跃的网络信息 2 获取随机新的网络信息
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            let data = res.data.data; ////拿到服务器返回的数据结果
            console.log("获取到网络信息:", data);
            this.$router.push({
              path: "threadNetworkNewStart",
              query: data
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    changeHostInfo() {
      ////一个主机被点击了
      this.$router.push({
        path: 'addChangeHost',
        query: { type: 'deviceManageChange', uniqueCode16: this.oneHostData.uniqueCode16 }
      })
    }

  },
  computed: {
  },
  mounted() {
    console.log("mounted阶段");
  },
  created() {
    console.log("created阶段");
    this.query = this.$route.query;
    this.oneHostData = this.$store.state.configinfo.oneHostData; ///拿到仓库当前主机的信息
    this.oneHostDeviceListData = this.$store.state.configinfo.oneHostDeviceListData; ///拿到仓库当前主机下的设备列表
    console.log(this.query);
    console.log(this.oneHostData);
    console.log(this.oneHostDeviceListData);
    //  this.$forceUpdate()  ////强制更新视图
  }
};
</script>

<style>
.device_go_online_btn_corol {
  color: var(--primary-color);
}
</style>
